function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import config from 'react-global-configuration';
import { userGetLoaded } from '../Entity/User';
import { profileGetLoaded } from '../Entity/Profile';
import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS, UI_OPERATION_STATUS_REASON_BLOCKED, UI_OPERATION_STATUS_REASON_UNRECOGNIZED, UI_OPERATION_STATUS_REASON_FLOOD, UI_OPERATION_STATUS_REASON_UNKNOWN } from '../UI';
export var SET_UID = 'SET_UID';
export function userSetCurrentUid(data) {
  return {
    type: SET_UID,
    data: data
  };
}
export var SET_LOGGED_IN = 'SET_LOGGED_IN';
export function userSetLoggedIn(data) {
  return {
    type: SET_LOGGED_IN,
    data: data
  };
}
export var SET_VALID_ONE_TIME_LOGIN = 'SET_VALID_ONE_TIME_LOGIN';
export function validOneTimeLogin(data) {
  return {
    type: SET_VALID_ONE_TIME_LOGIN,
    data: data
  };
}
export var SET_PASSWORD_RESET_TOKEN = 'SET_PASSWORD_RESET_TOKEN';
export function passResetToken(data) {
  return {
    type: SET_PASSWORD_RESET_TOKEN,
    data: data
  };
}
export var userGetCurrent = function userGetCurrent() {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'current', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    fetch("".concat(API_URL, "/user?_format=json"), {
      credentials: 'include'
    }).then(function (response) {
      if (response.ok) return response.json();else throw new Error();
    }).then(function (response) {
      dispatch(userGetLoaded(response.uid[0].value, response));
      // It's possible that a user has multiple profiles.
      // We simply load them all
      if (response.profiles) {
        response.profiles.forEach(function (profile) {
          dispatch(profileGetLoaded(profile.profile_id[0].value, profile));
        });
      }
      dispatch(userSetCurrentUid(response.uid[0].value));
      dispatch(userSetLoggedIn(true));
      dispatch(setOperationStatus('user', 'current', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(userSetLoggedIn(false));
      dispatch(userSetCurrentUid(null));
      dispatch(setOperationStatus('user', 'current', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var userLogin = function userLogin(username, password) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'login', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    fetch("".concat(API_URL, "/user/login?_format=json"), {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({
        name: username,
        pass: password
      })
    }).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
        var error;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (response.ok) {
                _context.next = 7;
                break;
              }
              _context.next = 3;
              return response.json();
            case 3:
              error = _context.sent;
              if (!error.message) {
                _context.next = 6;
                break;
              }
              throw new Error(error.message);
            case 6:
              throw new Error('Something went wrong.');
            case 7:
              return _context.abrupt("return", response.json());
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).then(function () {
      dispatch(userGetCurrent());
      dispatch(setOperationStatus('user', 'login', UI_OPERATION_STATUS_SUCCESS, null));
    }).catch(function (error) {
      var reason;
      switch (error.message) {
        case 'The user has not been activated or is blocked.':
          reason = UI_OPERATION_STATUS_REASON_BLOCKED;
          break;
        case 'Too many failed login attempts from your IP address. This IP address is temporarily blocked.':
          reason = UI_OPERATION_STATUS_REASON_FLOOD;
          break;
        case 'Sorry, unrecognized username or password.':
          reason = UI_OPERATION_STATUS_REASON_UNRECOGNIZED;
          break;
        default:
          reason = UI_OPERATION_STATUS_REASON_UNKNOWN;
      }
      dispatch(setOperationStatus('user', 'login', UI_OPERATION_STATUS_ERROR, reason));
    });
  };
};
export var userRegisterWithPassword = function userRegisterWithPassword(username, email, password, urlParams) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');

    // urlParams can be used in the backend to for example create a type of
    // profile and link it to the user.
    fetch("".concat(API_URL, "/user/register?_format=json&").concat(new URLSearchParams(urlParams).toString()), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        mail: [{
          value: email
        }],
        name: [{
          value: username
        }],
        pass: [{
          value: password
        }]
      })
    }).then(function (response) {
      if (response.ok) return response.json();else throw new Error();
    }).then(function () {
      dispatch(userLogin(username, password));
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var userRegisterWithoutPassword = function userRegisterWithoutPassword(username, email) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    fetch("".concat(API_URL, "/user/register?_format=json"), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        mail: email,
        name: username
      })
    }).then(function (response) {
      if (response.ok) return response.json();else throw new Error();
    }).then(function () {
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_SUCCESS));
    }).catch(function () {
      dispatch(setOperationStatus('user', 'register', UI_OPERATION_STATUS_ERROR));
    });
  };
};
export var userLogout = function userLogout() {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'logout', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var logoutToken;
    fetch("".concat(API_URL, "/session/token/logout?_format=json"), {
      credentials: 'include'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      logoutToken = response.logout_token;
      fetch("".concat(API_URL, "/user/logout?_format=json&token=").concat(logoutToken), {
        method: 'POST',
        credentials: 'include'
      }).then(function () {
        // After logging out the user, the browser is still caching the previous,
        // logged in, state. To avoid the user from going back to this state, we
        // fetch the user from the backend again, so the browser will cache this
        // new state. This request in userGetCurrent will fail, resetting the user
        // data in the redux state.
        dispatch(userGetCurrent());
        dispatch(setOperationStatus('user', 'logout', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('user', 'logout', UI_OPERATION_STATUS_ERROR));
      });
    });
  };
};
export var oneTimeLogin = function oneTimeLogin(uid, timestamp, hash) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'one_time_login', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var csrfToken;
    fetch("".concat(API_URL, "/session/token"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/user/login/token?_format=json"), {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          uid: uid,
          timestamp: timestamp,
          hash: hash
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function (response) {
        dispatch(passResetToken(response.pass_reset_token));
        dispatch(validOneTimeLogin(true));
        dispatch(userGetCurrent());
        dispatch(setOperationStatus('user', 'one_time_login', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(passResetToken(null));
        dispatch(validOneTimeLogin(false));
        dispatch(setOperationStatus('user', 'one_time_login', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};
export var forgotPassword = function forgotPassword(name) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'forgot_password', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var csrfToken;
    fetch("".concat(API_URL, "/session/token"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/user/reset?_format=json"), {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          name: name
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function () {
        dispatch(setOperationStatus('user', 'forgot_password', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('user', 'forgot_password', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};
export var resetPassword = function resetPassword(password, passResetToken) {
  return function (dispatch) {
    dispatch(setOperationStatus('user', 'reset_password', UI_OPERATION_STATUS_REQUEST));
    var API_URL = config.get('API_URL');
    var csrfToken;
    fetch("".concat(API_URL, "/session/token"), {
      credentials: 'include'
    }).then(function (response) {
      return response.text();
    }).then(function (response) {
      csrfToken = response;
      fetch("".concat(API_URL, "/user/password?_format=json"), {
        method: 'PATCH',
        credentials: 'include',
        body: JSON.stringify({
          password: password,
          pass_reset_token: passResetToken
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        }
      }).then(function (response) {
        if (response.ok) return response.json();else throw new Error();
      }).then(function () {
        dispatch(setOperationStatus('user', 'reset_password', UI_OPERATION_STATUS_SUCCESS));
      }).catch(function () {
        dispatch(setOperationStatus('user', 'reset_password', UI_OPERATION_STATUS_ERROR));
      });
    }).catch(function () {});
  };
};